import { render } from "./egyptianNeighbors.vue?vue&type=template&id=ac633b9c&scoped=true"
import script from "./egyptianNeighbors.vue?vue&type=script&lang=js"
export * from "./egyptianNeighbors.vue?vue&type=script&lang=js"

import "./egyptianNeighbors.vue?vue&type=style&index=0&id=ac633b9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac633b9c"]])

export default __exports__